/*=========================================================================================
  File Name: moduleDashboardMutations.js
  Description: Dashboard Module Mutations
==========================================================================================*/

export default {
	// API
	SET_DEVICES(state, devices) {
		state.devices = devices;
	},

	SET_DEVICES_STATUS(state, status) {
		state.devicesStatus = status;
	},

	UPDATE_DEVICE(state, device) {
		const deviceIndex = state.devices.findIndex(t => t.id === device.id);
		Object.assign(state.devices[deviceIndex], device);
	},

	UPDATE_SENSOR_IN_DEVICE(state, data) {
		const sensor = data.sensor || {};
		const deviceIndex = state.devices.findIndex(t => t.id === sensor.device_id);

		if (deviceIndex != -1) {
			const device = state.devices[deviceIndex];
			// find accessories
			const accessoryIndex = device.accessories.findIndex(t => t.id === sensor.accessory_id);
			if (accessoryIndex != -1) {
				const accessory = device.accessories[accessoryIndex];
				const sensorIndex = accessory.sensors.findIndex(t => t.id === sensor.id);
				if (sensorIndex != -1) {
					device.accessories[accessoryIndex].sensors = [sensor];
					Object.assign(state.devices[deviceIndex], { ...device, sensorDataUpdatedAt: data.updated_at || "" });
				}
			}
		}
	},

	DELETE_DEVICE(state, deviceId) {
		const deviceIndex = state.devices.findIndex(t => t.id == deviceId);
		state.devices.splice(deviceIndex, 1);
	},

	SET_SENSOR_ALERTS(state, sensorAlerts) {
		state.sensorAlerts = sensorAlerts;
	},

	UPDATE_SENSOR_ALERT(state, sensorAlert) {
		const sensorAlertIndex = state.sensorAlerts.findIndex(t => t.id === sensorAlert.id);
		if (sensorAlertIndex != -1) {
			Object.assign(state.sensorAlerts[sensorAlertIndex], sensorAlert);
		} else {
			state.sensorAlerts.unshift(sensorAlert);
		}
	},
	REMOVE_SENSOR_ALERT(state, remove_alert_data) {
		const sensorAlertIndex = state.sensorAlerts.findIndex(t => t.id === remove_alert_data.id);
		if (sensorAlertIndex != -1) {
			state.sensorAlerts.splice(sensorAlertIndex, 1);
		}
	},

	SET_CATEGORIES(state, categories) {
		state.categories = categories;
	},

	SET_IS_FETCHED_DEVICES(state, isFetchedDevices) {
		state.isFetchedDevices = isFetchedDevices;
	},

	SET_IS_FETCHED_SENSOR_ALERTS(state, isFetchedSensorAlerts) {
		state.isFetchedSensorAlerts = isFetchedSensorAlerts;
	}
};
